import React from 'react';
import { Skeleton } from '@mui/material';
import styles from './SkeletonsStyles.module.scss';

interface CampaignHeaderSkeletonProps {
  isSummary: boolean;
}

const CampaignHeaderSkeleton: React.FC<CampaignHeaderSkeletonProps> = (props) => {
  const { isSummary } = props;
return (
  <div className={styles.HeaderSkeleton}>
    <div className={styles.HeaderSkeletonRow}>
      <div className={styles.HeaderSkeletonColumn}>
        <Skeleton variant="circular" width={42} height={42} />
        <Skeleton variant="text" width={210} height={42} />
        <Skeleton variant="text" width={210} height={32} />
        <Skeleton variant="circular" width={42} height={42} />
      </div>
      <div className={styles.HeaderSkeletonColumn} style={{ justifyContent: "flex-end" }}>
        <Skeleton variant="rounded" width={170} height={42} />
        <Skeleton variant="circular" width={42} height={42} />
        <Skeleton variant="circular" width={42} height={42} />
        <Skeleton variant="circular" width={42} height={42} />
        <Skeleton variant="circular" width={42} height={42} />
        <Skeleton variant="circular" width={42} height={42} />
      </div>
    </div>

    <div className={styles.HeaderSkeletonRow}>
      <div className={styles.HeaderSkeletonColumn}>
        <Skeleton variant="text" width={80} height={35} />
        <Skeleton variant="rounded" width={40} height={35} />
        <Skeleton variant="rounded" width={70} height={35} />
        <Skeleton variant="rounded" width={180} height={35} />
        <Skeleton variant="rounded" width={180} height={35} />
        <Skeleton variant="rounded" width={180} height={35} />
      </div>
    </div>

    <div className={styles.HeaderSkeletonRow}>
      <div className={styles.HeaderSkeletonColumn}>
        <Skeleton variant="rounded" width={180} height={35} />
        { !isSummary && (
          <>
            <Skeleton variant="rounded" width={180} height={35} />
            <Skeleton variant="rounded" width={180} height={35} />
          </>
        )}
      </div>
    </div>

  </div>
);
};

export default CampaignHeaderSkeleton;
